import { motion } from "framer-motion";
import { ClipboardList, IdCard, Camera, FileText, BadgeCheck, ShoppingCart, Siren } from "lucide-react";
import { WhatsAppIcon } from "@/components/BrandIcons";

const WA_LINK = "https://wa.me/6285891144895";

const steps = [
  { n: 1, title: "PERSONAL IDENTITY", icon: IdCard, testid: "term-step-identity" },
  { n: 2, title: "SELFIE WITH IDENTITY", icon: Camera, testid: "term-step-selfie-id" },
  { n: 3, title: "SELFIE WITH A PIECE OF PAPER #TEAMJAV", icon: FileText, testid: "term-step-selfie-paper" },
  { n: 4, title: "VERIFICATION PROCESS", icon: BadgeCheck, testid: "term-step-verification" },
];

const services = [
  {
    icon: ShoppingCart,
    title: "Admin Buy Access",
    desc: "JOIN HOSTER / BUYING SLOT",
    testid: "service-buy-access",
  },
  {
    icon: Siren,
    title: "Problem Contact",
    desc: "REPORT ISSUES WHEN PLAYING",
    testid: "service-problem-contact",
  },
];

export default function Terms() {
  return (
    <section data-testid="terms-page" className="mx-auto min-h-screen max-w-5xl px-6 pb-24 pt-32">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="glass-card rounded-3xl p-8 md:p-12"
      >
        <div className="flex items-center justify-center gap-3 border-b border-dashed border-emerald-300/20 pb-6">
          <ClipboardList size={22} className="text-emerald-300" />
          <h1
            data-testid="terms-title"
            className="font-display text-lg font-bold tracking-[0.2em] text-emerald-200 md:text-2xl"
          >
            TERMS AND CONDITIONS FOR JOINING HOSTER
          </h1>
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-2">
          {steps.map((s, i) => (
            <motion.div
              key={s.testid}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.15 + i * 0.1 }}
              data-testid={s.testid}
              className="glass-card flex items-center gap-4 rounded-2xl p-5 transition-transform duration-300 hover:-translate-y-1"
            >
              <div
                className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-emerald-400 text-[#032117]"
                style={{ boxShadow: "0 0 20px rgba(52,211,153,0.5)" }}
              >
                <span className="font-display text-lg font-bold">{s.n}</span>
              </div>
              <div className="flex items-center gap-2">
                <s.icon size={16} className="shrink-0 text-emerald-300" />
                <h3 className="font-display text-sm font-bold tracking-wider text-emerald-100 md:text-base">
                  {s.title}
                </h3>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="mt-24 text-center"
      >
        <h2
          data-testid="admin-service-title"
          className="font-display text-3xl font-bold tracking-[0.15em] text-emerald-300 text-glow-emerald md:text-4xl"
        >
          ADMIN SERVICE
        </h2>
        <p
          data-testid="admin-service-subtitle"
          className="mt-4 text-xs font-semibold tracking-[0.3em] text-emerald-100/60 md:text-sm"
        >
          OUR TEAM READY TO HELP U ANYTIME, 24/7
        </p>
        <div className="mx-auto mt-4 h-px w-16 bg-gradient-to-r from-transparent via-amber-400 to-transparent" />
      </motion.div>

      <div className="mx-auto mt-12 grid max-w-3xl gap-6 md:grid-cols-2">
        {services.map((srv, i) => (
          <motion.div
            key={srv.testid}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.55, delay: 0.4 + i * 0.12 }}
            data-testid={srv.testid}
            className="glass-card flex items-center gap-5 rounded-2xl p-6 transition-transform duration-300 hover:-translate-y-1"
          >
            <div
              className="relative flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-emerald-400 text-[#032117]"
              style={{ boxShadow: "0 0 30px rgba(52,211,153,0.45)" }}
            >
              <srv.icon size={28} />
              <span className="absolute -bottom-1 -right-1 h-3 w-3 rounded-full border-2 border-[#062418] bg-emerald-300" />
            </div>
            <div>
              <h3 className="font-display text-lg font-bold text-emerald-100">{srv.title}</h3>
              <p className="mt-1 text-xs font-semibold tracking-[0.15em] text-emerald-100/60">{srv.desc}</p>
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${srv.testid}-button`}
                className="mt-3 inline-flex items-center gap-2 rounded-full border border-emerald-300/30 bg-emerald-400/10 px-4 py-1.5 text-xs font-bold tracking-wider text-emerald-200 transition-colors duration-300 hover:bg-emerald-400/20"
              >
                <WhatsAppIcon size={14} /> +6285891144895
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
